import { render, staticRenderFns } from "./index.vue?vue&type=template&id=53de4564&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53de4564",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53de4564')) {
      api.createRecord('53de4564', component.options)
    } else {
      api.reload('53de4564', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=53de4564&scoped=true&", function () {
      api.rerender('53de4564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/h5/spread/spreadClassify/index.vue"
export default component.exports